import React from 'react';
import PropTypes from 'prop-types';
import Config from '../../Config';

const config = new Config();

const ApprovalEntity = (props) => {
  const {
    startNewApplication,
    finishApplication,
    application,
    redirectionInfo,
    showEmbeddedExperience,
    isLeaving,
  } = props;

  const isTseu = (config.tseuChangesEnabled && application && application.isTSEU) ||
    (redirectionInfo && redirectionInfo.isTseu);
  const email = isTseu ? 'newaccountservices@tradestation.eu' : 'newaccountservices@tradestation.com';
  return (
    <div>
      <section className="flow-text">
        <div className="container">
          <div className="row">
            <div className="col col-md-12 col-lg-8 col-lg-offset-2">
              <h1 className="h1_secondary text-center">Thank you for choosing</h1>
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col col-md-12 col-lg-8 col-lg-offset-2 text-center">
                <br /><img src="images/tradestation.png" alt="" className="ts-logo-thankyou-page" /><br /><br />
                {/*
                  The two paths arrive here having done opposite things, so they need opposite
                  instructions. A PDF applicant still holds an unsent application; an embedded
                  applicant submitted theirs to Formstack already, and repeating the "email it in"
                  instruction to them reads as though that submission did not count.
                  FR-006: this copy is AOP's only obligation — the upload and the Formstack Sign
                  mechanics are entirely vendor-owned. The signing flow is the same for TSS and
                  TSEU, which is why the entity-specific address does not appear on this branch.
                */}
                {showEmbeddedExperience
                  ? (
                    <p className="p_leadForm">
                      Thank you for submitting your application. You and the individual(s) listed
                      on your TradeStation entity certificate will receive an email shortly to
                      review and sign the application electronically. Once all required signatures
                      are received, we will begin processing your account. If you have any
                      questions, please reach out to us using the &ldquo;Contact Us&rdquo; link
                      below.
                    </p>
                  )
                  : (
                    <p className="p_leadForm">
                      Once you have completed the application and submitted it to&nbsp;
                      <a className="email-link" href={`mailto:${email}`} >
                        {email}
                      </a>,<br /> a representative will contact you to complete the approval process.
                    </p>
                  )}
              </div>
            </div>
            <div className="row pending-btn-group">
              <div className="col col-md-4 col-md-offset-2 col-lg-4 col-lg-offset-2 col-sm-12 border-intro text-center">
                <button
                  type="submit"
                  id="next_btn"
                  className="btn btn-raised btn-default btn-left do_capitalize ty-btn"
                  onClick={finishApplication}
                  disabled={isLeaving}
                >
                  I&apos;m Finished
                </button>
              </div>
              <div className="col col-md-4 col-lg-4 col-sm-12 text-center">
                <button
                  type="submit"
                  id="next_btn"
                  className="btn btn-raised btn-white btn-right do_capitalize ty-btn"
                  onClick={startNewApplication}
                  disabled={isLeaving}
                >
                  Add Another Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

ApprovalEntity.propTypes = {
  startNewApplication: PropTypes.func.isRequired,
  finishApplication: PropTypes.func.isRequired,
  application: PropTypes.shape(),
  showEmbeddedExperience: PropTypes.bool,
  isLeaving: PropTypes.bool,
  redirectionInfo: PropTypes.shape({
    isBusinessAppRedirection: PropTypes.bool,
    isTseu: PropTypes.bool,
  }),
};

export default ApprovalEntity;
